export const MainConfig = {
    AppDetails: {
        app_name: "Deliverakhs Tourist", 
        app_description: "Deliverάκης Touris English edition",
        app_identifier: "com.deliv.app",
        ios_app_version: "1.7.0", 
        android_app_version: 8
    },
    FirebaseConfig: {
        apiKey: "AIzaSyB4010Mfg5CWo98ydwx2o_Fitehdub_Ugk",
        authDomain: "deliverakhs-tourist.firebaseapp.com",
        databaseURL: "https://deliverakhs2021-default-rtdb.firebaseio.com",
        projectId: "deliverakhs2021",
        storageBucket: "deliverakhs2021.appspot.com",
        messagingSenderId: "1083111304454",
        appId: "1:1083111304454:web:efcf0df6b83e3e40f54287",
        measurementId: "G-SJ64YPP21P"
    },

    Google_Map_API_Key: {
        ios: "AIzaSyAq-bk3y8CGWkeFMsdhYsxPrePGe2ZdsfU",
        android: "AIzaSyDGJj7vBqXC1l_LOSrCC0vroypqch6t3Sw",
        web: "AIzaSyB4010Mfg5CWo98ydwx2o_Fitehdub_Ugk"
    },
    facebookAppId: "1193173024528211"
}